import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/lib/axios";

// ✅ Updated interface - id is always required by backend
export interface TestProcedurePayload {
  case_id: number;
  reported_name: string;
  test_name: string;
  units: string;
  normal_low: number | null;
  normal_high: number | null;
  result: string;
  result_unit: string | null;
  id: number; // ✅ Always required: 0 for create, actual id for update
}

export const fetchTestProcedures = createAsyncThunk(
  "testProcedures/fetch",
  async (caseId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/test_procedures?case_id=${caseId}`
      );
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch test procedures"
      );
    }
  }
);

export const addTestProcedure = createAsyncThunk(
  "testProcedures/add",
  async (payload: TestProcedurePayload, { rejectWithValue }) => {
    try {
      // ✅ Since API is upsert, we can send single object or array
      // Check if your API expects array or single object
      const requestPayload = Array.isArray(payload) ? payload : [payload];

      const response = await axiosInstance.post(
        "/add_test_procedures",
        requestPayload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "Failed to add test procedure"
      );
    }
  }
);

export const deleteTestProcedure = createAsyncThunk(
  "testProcedures/delete",
  async (testProcedureId: number, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/delete_test_procedures`, {
        params: {
          test_procedures_id: testProcedureId,
        },
        headers: {
          accept: "application/json",
        },
      });
      return testProcedureId;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "Failed to delete test procedure"
      );
    }
  }
);
